import { render } from "./sysMenuPanel.vue?vue&type=template&id=67425dd5&scoped=true"
import script from "./sysMenuPanel.vue?vue&type=script&lang=ts"
export * from "./sysMenuPanel.vue?vue&type=script&lang=ts"

import "./sysMenuPanel.vue?vue&type=style&index=0&id=67425dd5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67425dd5"

export default script